import CustomButton from '../../../common/components/CustomButton';
import CustomRadio from '../../../common/components/CustomRadio';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';
import KaraokeUploadFormView1AudioPlayer from './KaraokeUploadFormView1AudioPlayer';

type KaraokeUploadFormView1FieldName = 'background_order'|'offvocal_order'|'promotion';

// 地のフォーム
export default function KaraokeUploadFormView1({
  getValue,
  setValue,
  getErrors,
  onNext,
} : {
  getValue: (name: KaraokeUploadFormView1FieldName) => string,
  setValue: (name: KaraokeUploadFormView1FieldName, value: string) => void,
  getErrors: (name: KaraokeUploadFormView1FieldName) => FieldValidationErrorsType,
  onNext: () => void,
}) {
  const backgroundOrderOptions = [
    {
      value: 'file',
      title: '配信する',
      description: (
        <>
          背景動画でご指定の
          <br />
          ミュージックビデオが流れます。
        </>
      ),
    },
    {
      value: 'auto',
      title: '配信しない',
      description: (
        <>
          背景動画でカラオケ店のおまかせ映像が流れます。
          ミュージックビデオを持っていない方はこちらを選択。
          <br />
        </>
      ),
    },
  ];

  const offvocalOrderOptions = [
    {
      value: 'file',
      title: '持っている',
      description: (
        <>
          その音源がそのまま
          <br />
          カラオケ店で再生されます。
        </>
      ),
    },
    {
      value: 'vocal_removal',
      title: '持っていない',
      description: (
        <>
          「歌あり音源」にボーカル除去の
          <br />
          加工をして使用します。
          <KaraokeUploadFormView1AudioPlayer />
        </>
      ),
    },
  ];

  const promotionOptions = [
    {
      value: '1',
      title: 'はい',
      description: null,
    },
    {
      value: '0',
      title: 'いいえ',
      description: null,
    },
  ]

  return (
    <>
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body material_upload_layout">
            <dl>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <dt><label>さて、ミュージックビデオを配信しますか？</label></dt>
              <dd>
                <CustomRadio
                  options={backgroundOrderOptions}
                  value={getValue('background_order')}
                  setValue={(value) => setValue('background_order', value)}
                  validationErrors={getErrors('background_order')}
                />
              </dd>
            </dl>
            <dl>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <dt><label>「歌なし音源」のデータを持っていますか？</label></dt>
              <dd>
                <CustomRadio
                  options={offvocalOrderOptions}
                  value={getValue('offvocal_order')}
                  setValue={(value) => setValue('offvocal_order', value)}
                  validationErrors={getErrors('offvocal_order')}
                />
              </dd>
            </dl>
            <dl>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <dt><label>この曲がカラオケ配信されたらFrekulからもSNS等で宣伝していいですか？</label></dt>
              <dd>
                <CustomRadio
                  options={promotionOptions}
                  value={getValue('promotion')}
                  setValue={(value) => setValue('promotion', value)}
                  validationErrors={getErrors('promotion')}
                />
              </dd>
            </dl>

            <ul>
              <li className="bt">
                <CustomButton type="default" onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}

